<app-lazy-dropdown
    [label]="label"
    [control]="control"
    placeholder="Select {{userType || 'user'}}"
    [searchControl]="userFilter"
    [items]="userList"
    [totalCount]="totaluserCount"
    [offset]="userOffset"
    [paginationLimit]="paginationLimit"
    (loadMore)="getNextuser()"
    (filterChange)="filteruser($event)"
    [multiple]="multiple"
    (selectionChange)="onSelectionChange($event)"
></app-lazy-dropdown>
